import { Stack, styled } from '@mui/material'
import Iconfont from 'components/Iconfont'
import { memo } from 'react'
import { useLatencyMillisecond } from 'store/ws/hooks'

const ConnectionStatusWrap = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 4px;
  height: 16px;
  cursor: default;

  &.grey {
    color: ${({ theme }) => theme.color.text20};
  }
  &.green {
    color: ${({ theme }) => theme.color.notificationGreen02};
  }
  &.red {
    color: ${({ theme }) => theme.color.notificationRed02};
  }
  &.orange {
    color: ${({ theme }) => theme.color.notificationYellow02};
  }
`

enum LatencyCode {
  Disconnected,
  HighLatency,
  Unstable,
  Stable,
}

function getLatencyCode(latency: number) {
  if (latency > 0 && latency < 500) {
    return LatencyCode.Stable
  } else if (latency >= 500 && latency < 1500) {
    return LatencyCode.Unstable
  } else if (latency >= 1500 && latency < 3000) {
    return LatencyCode.HighLatency
  } else {
    return LatencyCode.Disconnected
  }
}

export const ConnectionStatus = memo(() => {
  const latency = useLatencyMillisecond()
  const latencyCode = getLatencyCode(latency)

  if (latencyCode === LatencyCode.HighLatency) {
    return (
      <ConnectionStatusWrap className="red">
        <Iconfont name="icon-connect3" size={16} />
        <span>High Latency {latency}ms</span>
      </ConnectionStatusWrap>
    )
  } else if (latencyCode === LatencyCode.Unstable) {
    return (
      <ConnectionStatusWrap className="orange">
        <Iconfont name="icon-connect2" size={16} />
        <span>Unstable Connection {latency}ms</span>
      </ConnectionStatusWrap>
    )
  } else if (latencyCode === LatencyCode.Stable) {
    return (
      <ConnectionStatusWrap className="green">
        <Iconfont name="icon-connect" size={16} />
        <span>Stable Connection {latency}ms</span>
      </ConnectionStatusWrap>
    )
  } else {
    return (
      <ConnectionStatusWrap className="grey">
        <Iconfont name="icon-connect" size={16} />
        <span>Disconnected</span>
      </ConnectionStatusWrap>
    )
  }
})
